import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrProjectProgressComponent } from './pr-project-progress.component';
import { PrProjectProgressBadgeComponent } from './pr-project-progress-badge/pr-project-progress-badge.component';
import { PrLoaderModule } from '../pr-loader/pr-loader.module';
@NgModule({
  declarations: [PrProjectProgressComponent, PrProjectProgressBadgeComponent],
  imports: [CommonModule, PrIconModule, PrLoaderModule],
  exports: [PrProjectProgressComponent],
})
export class PrProjectProgressModule {}
